import React from "react";

import InfoBox from "../InfoBox";

import { NavigationButtons } from "../NavigationButtons";

interface CompletedFlowGuardProps {
  onRestart: () => void;
}

export const CompletedFlowGuard: React.FC<CompletedFlowGuardProps> = ({
  onRestart,
}) => {
  return (
    <div className="step-content">
      <h1>Forløbet er allerede gennemført</h1>
      <InfoBox type="success">
        <p>
          Du har allerede gennemført dette forløb. Hvis du vil starte forfra,
          kan du klikke på knappen nedenfor.
        </p>
      </InfoBox>
      <NavigationButtons
        showBack={false}
        onNext={onRestart}
        nextText="Start forløbet på ny"
        alignment="start"
      />
    </div>
  );
};
